import internalTranferModule from "./internal-transfer";
import internalDispatchModule from "./internal-dispatch";
import internalHistoryModule from "./history";

export const internalTranferModules = {
  internalTransfer: internalTranferModule,
  internalDispatch: internalDispatchModule,
  internalHistory: internalHistoryModule,
};
